<template>
	<div style="height: 100%">
		<div class="d-flex justify-end">
			<v-icon color="secondary" @click="toggleTheme()">mdi-brightness-4</v-icon>
		</div>

		<v-row style="height: 100%" class="align-center">
			<v-col cols="12" md="7" lg="6" class="d-flex justify-center">
				<v-form ref="loginForm" >
					<div
						class="text-center"
						style="width: 300px"
					>
						<img
							src="https://s3.eu-central-1.amazonaws.com/manager.clickday.images/logo_colori.png"
							alt="Click Day Manager"
							height="120"
							class="mb-2"
						>
						<div v-if="errorMessage" class="error--text">{{ errorMessage }}</div>
						<v-text-field
							label="Email *"
							v-model="form.email"
							outlined
							dense
							:rules="[mixin_rules.required, mixin_rules.email]"
						></v-text-field>
						<v-text-field
							label="Password *"
							v-model="form.password"
							outlined
							dense
							name="password"
							:type="togglePassword ? 'password' : 'text'"
							:append-icon="togglePassword ? 'mdi-eye' : 'mdi-eye-off'"
							@click:append="() => (togglePassword = !togglePassword)"
							:rules="[mixin_rules.required]"
						></v-text-field>
						<div style="font-size: 13px" class="mb-6">
							Le credenziali ti sono state inviate per email.<br>Se non le trovi, contatta il referente della tua pratica.
						</div>
						<!-- <v-checkbox label="Ricordami" v-model="remember"></v-checkbox> -->
						<v-btn
							v-if="!isLoading"
							color="secondary"
							@click="submit()"
							class="mb-2"
							width="150"
						>
							Accedi
						</v-btn>
						<v-btn
							v-if="isLoading"
							color="success"
						>
							<span class="mr-2">Accesso in corso</span>
							<v-progress-circular
								:size="15"
								:width="2"
								indeterminate
								color="white"
							></v-progress-circular>
						</v-btn>
					</div>
				</v-form>
			</v-col>
		</v-row>

		<!--<div style="margin-top: 20vh">-->
		<!--	<div class="d-flex justify-center mb-13">-->
		<!--		Click Day Manager-->
		<!--	</div>-->
		<!--	<v-form ref="loginForm" class="d-flex justify-center">-->
		<!--		<div-->
		<!--			class="text-center"-->
		<!--			style="width: 600px"-->
		<!--		>-->
		<!--			<div v-if="errorMessage" class="error&#45;&#45;text">{{ errorMessage }}</div>-->
		<!--			<v-text-field-->
		<!--				label="Email *"-->
		<!--				v-model="form.email"-->
		<!--				outlined-->
		<!--				dense-->
		<!--				:rules="[mixin_rules.required, mixin_rules.email]"-->
		<!--			></v-text-field>-->
		<!--			<v-text-field-->
		<!--				label="Password *"-->
		<!--				v-model="form.password"-->
		<!--				outlined-->
		<!--				dense-->
		<!--				name="password"-->
		<!--				:type="togglePassword ? 'password' : 'text'"-->
		<!--				:append-icon="togglePassword ? 'mdi-eye' : 'mdi-eye-off'"-->
		<!--				@click:append="() => (togglePassword = !togglePassword)"-->
		<!--				:rules="[mixin_rules.required]"-->
		<!--			></v-text-field>-->
		<!--			&lt;!&ndash; <v-checkbox label="Ricordami" v-model="remember"></v-checkbox> &ndash;&gt;-->
		<!--			<v-btn-->
		<!--				v-if="!isLoading"-->
		<!--				color="secondary"-->
		<!--				@click="submit()"-->
		<!--				class="mb-2"-->
		<!--				width="150"-->
		<!--			>-->
		<!--				Accedi-->
		<!--			</v-btn>-->
		<!--			<v-btn-->
		<!--				v-if="isLoading"-->
		<!--				color="success"-->
		<!--			>-->
		<!--				<span class="mr-2">Accesso in corso</span>-->
		<!--				<v-progress-circular-->
		<!--					:size="15"-->
		<!--					:width="2"-->
		<!--					indeterminate-->
		<!--					color="white"-->
		<!--				></v-progress-circular>-->
		<!--			</v-btn>-->
		<!--		</div>-->
		<!--	</v-form>-->
		<!--</div>-->
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from "@/event-bus";

export default {
	data() {
		return {
			isLoading: false,
			errorMessage: null,

			form: {
				email: null,
				password: null,
			},
			togglePassword: true,
			// remember: false,
		}
	},

	computed: {
		...mapGetters({
			user: 'auth/user',
			isAuthenticated: 'auth/isAuthenticated',
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
		}),
	},

	created() {
		eventBus.$on('send-login-error', error => {
			this.errorMessage = error;
		});
	},

	methods: {
		...mapActions({
			login: 'auth/login'
		}),
		toggleTheme() {
			this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
			localStorage.setItem('click_day_manager_dark_theme', this.$vuetify.theme.dark.toString());
		},
		async submit() {
			if(!this.$refs.loginForm.validate()) return;
			this.errorMessage = null;
			this.isLoading = true;
			await this.login(this.form);
			if (this.isAuthenticated) {
				// scelgo la rotta in base al tipo di utente
				if (this.isAccountManager) await this.$router.push({ name: 'accordi' })
				else if (this.isCoordinatore) await this.$router.push({ name: 'pratiche' })
				else if (this.isCliente) await this.$router.push({ name: 'home' })
			}
			this.isLoading = false;
		}
	},
}
</script>
